export enum Unit {
  FootPoundForce = 'ft.lbf',
  NewtonMeter = 'Nm',
}
